import React, { Component } from 'react';
import { Link } from "react-router-dom";

export default class GoBackTokenPage extends Component {

  render() {

    const data = this.props.data;

    return (
      <div class="text-left">
        <Link to={{ pathname: "/dashboard/tokenpage" }}>
          <i class="fa fa-2x fa-arrow-left m-r-10" />
          <h4 id="inline"> {data.back}</h4>
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/goback.js